var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActionBarMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 4",
    style: {
      enableBackground: "new 0 0 16 4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C4566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-More_x2F_icon_x5F_more",
    transform: "translate(-11.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 13,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    className: "st0",
    cx: 19,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    className: "st0",
    cx: 25,
    cy: 18,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionBarMore);
export default __webpack_public_path__ + "static/media/icon-action-bar-more.6f41d303f516bbe09242f493750974fd.svg";
export { ForwardRef as ReactComponent };